<div class="ac-modal">
	<!-- Header -->
	<div class="header" *ngIf="titleDCRKey">
		<h3 class="col-24 text-28-extra-bold text-align-center" [dcrHTMLKey]="titleDCRKey">
			<span>{{ titleDCRKey }}</span>
		</h3>
	</div>

	<!-- Content -->
	<div
		class="dialog-content padding-horizontal-30"
		[ngClass]="{ 'padding-top-30': titleDCRKey, 'padding-top-60': !titleDCRKey, 'padding-bottom-30': disclaimerDCRKey, 'padding-bottom-80': !disclaimerDCRKey }"
	>
		<div class="col-24 text-14" [dcrHTMLKey]="contentDCRKey">
			<div>{{ contentDCRKey }}</div>
		</div>
	</div>

	<!-- Disclaimer -->
	<div class="dialog-content padding-horizontal-30 padding-bottom-80" *ngIf="disclaimerDCRKey">
		<ac-disclosure [isExpandable]="false" [dcrKey]="disclaimerDCRKey"></ac-disclosure>
	</div>
</div>
